// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/vor-tracking-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/vor-tracking-procedures/vor-tracking-procedures.js';

mount([g0]);
